import React from 'react';
import { Table } from 'antd';

import styles from './ProductTypesTable.module.css';

const columns = [
  {
    title: 'Type',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Android Image',
    dataIndex: 'image_url_android',
    key: 'image_url_android',
    render: url => (url === '' ? <span>No image</span> : <img className={styles.Img} alt="" src={url} />),
  },
  {
    title: 'iOS Image',
    dataIndex: 'image_url_ios',
    key: 'image_url_ios',
    render: url => (url === '' ? <span>No image</span> : <img className={styles.Img} alt="" src={url} />),
  },
];

const ProductTypesTable = props => {
  const { loading, product_types } = props;

  return (
    <Table loading={loading} columns={columns} dataSource={product_types} pagination={false} rowKey={row => row.id} />
  );
};

export default ProductTypesTable;



// WEBPACK FOOTER //
// ./src/components/ProductType/ProductTypesTable.js